import styled from 'styled-components';

export const styles = {
  inputWidth: {
    width: 300,
  },
};

export const RadioItem = styled.div`
  width: 600px;
  max-width: 100%;
  display: flex;
  align-items: center;

  &:last-child {
    margin-bottom: 0;
  }

  & > *:last-child {
    margin-left: auto;
  }
`;

export const RadioLabel = styled.span`
  width: 150px;
`;



// WEBPACK FOOTER //
// ./src/components/IterioApp/Users/AddTag/AddTag.styles.js